export default "/images/c16fc3ae958afa37197ffdc419e9b68b.avif";